module.exports = __webpack_public_path__ + "img/an.39c5d05e.svg";